import React from 'react';
import { Tooltip } from '@mui/material';

// Tooltip that also works with a thumb: opens on touch immediately and stays long enough to read.
const TouchTooltip = ({ children, ...props }) => (
  <Tooltip arrow enterTouchDelay={0} leaveTouchDelay={5000} {...props}>
    {children}
  </Tooltip>
);

export default TouchTooltip;
